// Type Alias Definition
type SumInput = (string | number)[];
export function UnionSum(a: SumInput, b: SumInput): number {
	return parseInt(`${a}`, 10) + parseInt(`${b}`, 10);
}

// Index Signnature Object
type Person = {
	age: number;
	name: string;
	[anyKey: string]: string | number | boolean;
};
const thuta: Person = {
	age: 21,
	name: 'Thuta Sann',
	city: 'yangon',
	isMale: true,
};

// Discriminatied Type
type Student = {
	age: number;
	name: string;
	study: () => void;
	type: 'student';
};
type Dog = {
	age: number;
	name: string;
	bark: () => void;
	type: 'dog';
};

export function makeNoise(dogOrPerson: Dog | Student): void {
	switch (dogOrPerson.type) {
		case 'dog': {
			dogOrPerson.bark();
			break;
		}
		case 'student': {
			dogOrPerson.study();
			break;
		}
	}
}
